import React, {
  useEffect,
  useRef,
  useState,
  Suspense,
  lazy,
  useMemo,
} from "react";

import {
  Button,
  Grid,
  Typography,
  Tooltip,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert as MuiAlert,
  TablePagination,
} from "@mui/material";
import axios from "axios";
import Layout from "../../layout/Layout";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment/moment";
import * as XLSX from "xlsx/xlsx.mjs";
import {
  config,
  employeeAttandenceAPI,
  handleHrMasterAPI,
  manageCompaniesAPI,
} from "../../config";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import DoneIcon from "@mui/icons-material/Done";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import MapIcon from "@mui/icons-material/Map";
//tab library
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { styled } from "@mui/material/styles";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { MobileDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { _getDropdownListData } from "../../service";
import { LoadingButton } from "@mui/lab";
import DataTable from "react-data-table-component";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { AlertMessage } from "../../components/AlertMessage";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: "#ffffff",
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const editedAttendanceStorageKey = "edited-attendance-cells";

const getStoredEditedCells = () => {
  try {
    return JSON.parse(localStorage.getItem(editedAttendanceStorageKey) || "{}");
  } catch {
    return {};
  }
};

function EmployeeAttendance() {
  const childRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const limit = 10;

  const [attendanceReport, setAttendanceReport] = useState([]);

  const [monthlyAttendanceReport, setMonthlyAttendanceReport] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [monthlyPage, setMonthlyPage] = useState(0);
  const [monthlyRowsPerPage, setMonthlyRowsPerPage] = useState(10);
  const [value, setValue] = React.useState("1");
  const [selectedEmployee, setSelectedEmployeeList] = useState(0);
  const [fromDate, setFromDate] = React.useState(location.state?.date || dayjs().format("YYYY-MM-DD"));
  const [toDate, setToDate] = React.useState(location.state?.date || dayjs().format("YYYY-MM-DD"));
  const [daysinMonth, handleDaysinMonth] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeID, setEmployeeID] = useState(0);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(10);
  const [rowsPerPage, setRowsPerPage] = useState(10); //change to 10 after you remove paginationRowsPerPageOptions
  const [currentPage, setCurrentPage] = useState(1);
  const [companyNames, setCompanyNames] = React.useState("");
  const [selectedCompany, setSelectedCompany] = useState(location.state?.companyID || 0);
  const [companyList, setComanyList] = useState([]);
  const [companyName, setCompanyName] = useState(location.state?.companyID || 0);
  const [columnName, setColumnName] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [selectedStatusVal, setSelectedStatusVal] = useState(location.state?.status || "");

  useEffect(() => {
    if (location.state?.status) {
      setSelectedStatusVal(location.state.status);
    }
  }, [location.state?.status]);

  // Dialog Box
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedReason, setSelectedReason] = useState("");

  const [reason, setReason] = useState("");
  const [error, setError] = useState(false);
  const [editedCells, setEditedCells] = useState(getStoredEditedCells);

  const downloadDailyAttendanceExcel = () => {
    const data = JSON.stringify({
      txtStartTime: dayjs(fromDate).format("YYYY-MM-DD"),
      txtEndTime: dayjs(toDate).format("YYYY-MM-DD"),
      intEmployeeID: employeeID,
      intCompanyId: companyName,
      intType: 15,
    });

    config.method = "POST";
    config.data = data;
    config.url = employeeAttandenceAPI;

    axios(config)
      .then(function (response) {
        const newData = response.data["result"].map((row) => {
          delete row.id;
          delete row.employee_id;
          delete row.date;
          delete row.created_at;
          delete row.photo;

          row["Employee Name"] = row.employee_name ? row.employee_name : "NA";
          row["First In"] = row.start_time
            ? moment(row.start_time).format("MMM DD, YYYY, hh:mm a")
            : "NA";
          row["Last out"] = row.end_time
            ? moment(row.end_time).format("MMM DD, YYYY, hh:mm a")
            : "NA";
          row["Projects"] = row.project_names ? row.project_names : "NA";
          row["Total Hours"] = row.working_hours ? row.working_hours : "NA";
          row["Shift"] = !row.Shift
            ? "NA"
            : row.Shift == 1
            ? "Day Shift"
            : "Night Shift";
          row["Attendance Status"] = !row.attandence_status
            ? row.start_time
              ? "Full Day"
              : "-"
            : row.attandence_status == 1
            ? "Full Day"
            : row.attandence_status == 2
            ? "Half Day"
            : "Leave";

          return {
            "Employee Name": row["Employee Name"],
            "First In": row["First In"],
            "Last out": row["Last out"],
            Projects: row["Projects"],
            "Total Hours": row["Total Hours"],
            Shift: row["Shift"],
            "Attendance Status": row["Attendance Status"],
          };
        });
        const workSheet = XLSX.utils.json_to_sheet(newData);
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, "students");
        //Buffer
        let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
        //Binary string
        XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
        //Download
        XLSX.writeFile(
          workBook,
          `KG-ATTENDANCE-${moment().format("DD-MM-YYYY")}.xlsx`
        );
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  function getMonthFromDate(dateString) {
    const date = new Date(dateString);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const monthIndex = date.getMonth();
    return [monthNames[monthIndex - 1], monthNames[monthIndex]];
  }

  function formatDateNumber(dateNumber) {
    const theDate = new Date(moment(fromDate).format("YYYY-MM-DD"));
    const suffixes = ["th", "st", "nd", "rd"];
    const digit = dateNumber % 10;

    const date = theDate.getDate();
    const month = theDate.toLocaleString("default", { month: "short" });

    if (parseInt(dateNumber) >= 26 && parseInt(dateNumber) <= 31) {
      // If the dateNumber is between 26 and 31, return the previous month's name
      let previousMonth = new Date(theDate);

      previousMonth.setMonth(theDate.getMonth() - 1);
      const previousMonthName = previousMonth.toLocaleString("default", {
        month: "short",
      });
      // if (month) {
      //   let previousMonthName = "";
      //   if (month == "Jan") {
      //     previousMonthName = "Dec";
      //   } else if (month == "Feb") {
      //     previousMonthName = "Jan";
      //   } else if (month == "Mar") {
      //     previousMonthName = "Feb";
      //   } else if (month == "Apr") {
      //     previousMonthName = "Mar";
      //   } else if (month == "May") {
      //     previousMonthName = "Apr";
      //   } else if (month == "Jun") {
      //     previousMonthName = "May";
      //   } else if (month == "Jul") {
      //     previousMonthName = "Jun";
      //   } else if (month == "Aug") {
      //     previousMonthName = "Jul";
      //   } else if (month == "Sep") {
      //     previousMonthName = "Aug";
      //   } else if (month == "Oct") {
      //     previousMonthName = "Sep";
      //   } else if (month == "Nov") {
      //     previousMonthName = "Oct";
      //   } else if (month == "Dec") {
      //     previousMonthName = "Nov";
      //   }
      // }

      return dateNumber + " " + previousMonthName;
    } else {
      // Otherwise, return the current month's name
      return dateNumber + month;
    }
  }

  const downloadMonthlyAttendanceExcel = () => {
    const data = JSON.stringify({
      txtStartTime: moment(fromDate).format("YYYY-MM-DD"),
      txtEndTime: moment(toDate).format("YYYY-MM-DD"),
      intEmployeeID: employeeID,
      intCompanyId: selectedCompany,
      intType: 7,
    });

    config.method = "POST";
    config.data = data;
    config.url = employeeAttandenceAPI;

    axios(config)
      .then(function (response) {
        const newData = [];

        // Create header row
        const headerRow = [
          "Employee Name / Date",
          "Full Day",
          "Half Day",
          "Leave",
          ...daysinMonth.map((date) => formatDateNumber(date)),
        ];
        newData.push(headerRow);

        // Iterate through each employee's attendance data
        response.data["result"].forEach((employee) => {
          let fullday = 0;
          let halfday = 0;
          let leave = 0;

          // Calculate full day, half day, and leave counts
          for (let key in employee) {
            switch (employee[key]) {
              case 1:
                fullday++;
                break;
              case 2:
                halfday++;
                break;
              case 3:
                leave++;
                break;
            }
          }
          let paidSundays = 0;
          const currentDate = new Date(fromDate);
          daysinMonth.forEach((day) => {
            const dayInt = parseInt(day);
            let newDate;
            if (dayInt <= 25) {
              newDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), dayInt);
            } else {
              newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, dayInt);
            }
            if (newDate.getDay() === 0) { // Sunday
              const status = employee[dayInt];
              if (status !== 0) {
                const isUnpaid = (date) => {
                  if (date.getDay() === 0) return false;
                  const s = employee[date.getDate()];
                  return s === 3 || s === 0 || s === undefined || s === null;
                };
                const satDate = new Date(newDate);
                satDate.setDate(newDate.getDate() - 1);
                const monDate = new Date(newDate);
                monDate.setDate(newDate.getDate() + 1);
                if (!(isUnpaid(satDate) && isUnpaid(monDate))) {
                  paidSundays++;
                }
              }
            }
          });

          const finalLeave = Math.max(0, leave - paidSundays);

          const rowData = [
            employee.employee_name,
            fullday,
            halfday,
            finalLeave,
            ...daysinMonth.map((day) => {
              let cellValue;
              switch (employee[day]) {
                case 0:
                  cellValue = "-";
                  break;
                case 1:
                  cellValue = "F";
                  break;
                case 2:
                  cellValue = "H";
                  break;
                case 3:
                  cellValue = "L";
                  break;
                default:
                  cellValue = "-";
                  break;
              }
              return cellValue;
            }),
          ];

          newData.push(rowData);
        });

        const workSheet = XLSX.utils.aoa_to_sheet(newData);

        workSheet["!cols"] = [{ width: 40 }];

        const boldCenteredStyle = {
          font: { bold: true, size: 14, name: "Arial" },
          alignment: { horizontal: "center", vertical: "center" },
        };
        const monthArray = getMonthFromDate(
          dayjs(fromDate).format("YYYY-MM-DD")
        );

        workSheet["A1"] = {
          t: "s",
          v: `${monthArray[0]} - ${monthArray[1]} Monthly Attendance Report`,
          s: boldCenteredStyle,
        };
        workSheet["!merges"] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: daysinMonth.length + 3 } },
        ];

        // Insert empty row after the header row
        XLSX.utils.sheet_add_aoa(workSheet, [[]], { origin: "A2" });

        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workBook,
          workSheet,
          "employee_monthly_attendance"
        );

        //Buffer
        let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
        //Binary string
        XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
        //Download
        XLSX.writeFile(
          workBook,
          `KG-ATTENDANCE-${moment().format("DD-MM-YYYY")}.xlsx`
        );
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if ("2" == newValue) {
      handleMonthlyAttendanceReport();
      setDaysinMonth(new Date().getFullYear(), new Date().getMonth());
    } else {
      fetchAttendanceData(1, rowsPerPage);
    }
  };

  let tempRefs = useRef(false);

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 5,
        // intParentId: 42,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = manageCompaniesAPI;

      axios(config)
        .then(function (response) {
          response.data.result.unshift({ id: 0, company_name: "All" });
          setCompanyNames(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  const handleCompanyChange = (event) => {
    setSelectedCompany(event.target.value);
    //handleMonthlyAttendanceReport(event.target.value);
  };

  // Getting Company List
  useEffect(() => {
    config.method = "POST";
    config.data = JSON.stringify({ intType: 6 });
    config.url = manageCompaniesAPI;

    axios(config)
      .then(function (response) {
        response.data.result.unshift({ id: 0, company_name: "All" });
        setComanyList(response.data.result);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  // useEffect(() => {
  //   let data = {
  //     requestData: {
  //       intType: 6,
  //     },
  //     API: manageCompaniesAPI,
  //     setData: setComanyList,
  //   };

  //   _getDropdownListData(data);
  // }, []);

  let assetsRef = useRef(false);

  let temprefs1 = useRef(false);
  useEffect(() => {
    if (temprefs1.current === false) {
      fetchAttendanceData(1, rowsPerPage, 16);
    }
  }, []);

  const fetchAttendanceData = async (
    page,
    rowsPerPage,
    type = 16,
    columnName = "",
    sortDirection = ""
  ) => {
    const isFiltered = !!selectedStatusVal;
    const limitVal = isFiltered ? 10000 : (rowsPerPage ? rowsPerPage : 10);
    const offsetVal = isFiltered ? 0 : (rowsPerPage ? (page - 1) * rowsPerPage : 0);

    const data = JSON.stringify({
      intLimit: limitVal,
      intOffset: offsetVal,
      txtStartTime: dayjs(fromDate).format("YYYY-MM-DD"),
      txtEndTime: dayjs(toDate).format("YYYY-MM-DD"),
      intEmployeeID: employeeID,
      intCompanyId: companyName,
      txtColumnName: columnName,
      txtSortDirection: sortDirection,
      intType: type,
    });

    config.method = "POST";
    config.data = data;
    config.url = employeeAttandenceAPI;

    axios(config)
      .then(function (response) {
        let resData = response.data.data || [];
        
        // Filter by company name if selectedCompany/companyName is passed or initialized
        if (companyName && companyName !== 0) {
          const matchComp = companyList.find(c => c.id === companyName);
          if (matchComp) {
            resData = resData.filter(row => row.company_name === matchComp.company_name);
          }
        }

        // Apply status filter
        if (selectedStatusVal === "logged-in") {
          resData = resData.filter(row => row.start_time !== null && row.start_time !== undefined && row.start_time !== "");
        } else if (selectedStatusVal === "not-logged-in" || selectedStatusVal === "absent" || selectedStatusVal === "exception") {
          resData = resData.filter(row => !row.start_time);
        }

        // De-duplicate by employee name to keep only one row per employee when filtered
        if (isFiltered) {
          const uniqueMap = {};
          resData.forEach(row => {
            if (row.employee_name) {
              if (!uniqueMap[row.employee_name] || moment(row.start_time).isAfter(moment(uniqueMap[row.employee_name].start_time))) {
                uniqueMap[row.employee_name] = row;
              }
            }
          });
          resData = Object.values(uniqueMap);
        }

        setAttendanceReport(resData);
        setTotalCount(isFiltered ? resData.length : response.data.total_count);
      })
      .catch(function (error) {
        console.log(error);
        return [];
      });
  };

  const handleSort = (column, sortDirection) => {
    if (column.name) {
      let columnName = column.name.toLowerCase();
      setColumnName(columnName);
      setSortDirection(sortDirection);
      fetchAttendanceData(1, rowsPerPage, 16, columnName, sortDirection); // Ensure fetchAttendanceData is being called
    }
  };

  const handleMonthlyAttendanceReport = () => {
    const data = JSON.stringify({
      txtStartTime: dayjs(fromDate).format("YYYY-MM-DD"),
      intCompanyId: selectedCompany,
      intEmployeeID: selectedEmployee,
      intType: 7,
    });

    config.method = "POST";
    config.data = data;
    config.url = employeeAttandenceAPI;
    axios(config)
      .then(function (response) {
        setMonthlyAttendanceReport(response.data["result"]);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handlePageChange = (page) => {
    fetchAttendanceData(page, rowsPerPage);
    // downloadExcel(page, rowsPerPage);
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = async (newRowsPerPage) => {
    if (!employeeList.length) return; //when the table is rendered for the first time, this would trigger, and we don't need to call fetchAttendanceData again

    fetchAttendanceData(1, newRowsPerPage, 16, columnName, sortDirection);
    // downloadExcel(1, rowsPerPage);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  useEffect(() => {
    // if (assetsRef.current === false) {
    const data = JSON.stringify({
      intType: 7,
    });

    config.method = "POST";
    config.data = data;
    config.url = handleHrMasterAPI;

    axios(config)
      .then(function (response) {
        response.data.result.unshift({ id: 0, name: "All" });
        setEmployeeList(response.data.result);
      })
      .catch(function (error) {
        console.log(error);
      });

    return () => {
      assetsRef.current = true;
    };
    // }
  }, []);

  const setDaysinMonth = (year, month) => {
    let daysInPreviousMonth = new Date(year, month, 0).getDate();

    let days = [];

    for (let i = 26; i <= daysInPreviousMonth; i++) {
      if (i < 10) {
        i = "0" + i;
      }
      days.push("" + i);

      if (daysInPreviousMonth == i) {
        for (let j = 1; j < 26; j++) {
          if (j < 10) {
            j = "0" + j;
          }
          days.push("" + j);
        }
      }
      handleDaysinMonth(days);
    }
  };

  const columns = useMemo(() => [
    {
      name: "Employee Name",
      field: "id",
      sortable: true,
      width: "15%",
      selector: (row) => (row.employee_name ? row.employee_name : "NA"),
    },
    {
      name: "Track Location",
      width: "12%",
      selector: (row) => {
        return (
          <a
            href={`/employee-attendance-report/${row.ID}`}
            className="link-style"
            title={`View on Map`}
            target="_blank"
            style={{
              textDecoration: "underline",
              color: "#0c53a0",
              fontWeight: "bold",
              display: "inline-flex",
              alignItems: "center",
              gap: "4px"
            }}
          >
            <MapIcon sx={{ fontSize: 16 }} /> View Map
          </a>
        );
      },
    },
    {
      name: "Company Name",
      field: "id",
      sortable: true,
      selector: (row) => (row.company_name ? row.company_name : "NA"),
      width: "16%",
    },
    {
      name: "First In",
      field: "id",
      sortable: true,
      width: "16%",
      selector: (row) =>
        row.start_time
          ? moment(row.start_time).format("MMM DD, YYYY, hh:mm a")
          : "NA",
    },
    {
      name: "Last Out",
      field: "id",
      sortable: true,
      selector: (row) =>
        row.end_time
          ? moment(row.end_time).format("MMM DD, YYYY, hh:mm a")
          : "NA",
      width: "16%",
    },
    {
      name: "Project(s) Name",
      field: "id",
      sortable: true,
      width: "15%",
      selector: (row) =>
        row.project_names ? (
          <Tooltip title={row.project_names}>
            <InfoIcon className="icon_colorinfo" />
          </Tooltip>
        ) : (
          "NA"
        ),
    },
    {
      name: "Total Hours",
      field: "id",
      sortable: true,
      width: "15%",
      selector: (row) => (row.working_hours ? row.working_hours : "NA"),
    },
    {
      name: "Shift",
      field: "id",
      sortable: true,
      selector: (row) =>
        !row.Shift ? "NA" : row.Shift == 1 ? "Day Shift" : "Night Shift",
    },
    {
      name: "Attendance Status",
      field: "id",
      width: "15%",
      cell: (row) =>
        !row.attandence_status ? (
          row.start_time ? (
            <IconButton
              variant="outlined"
              className="align-cancelbutton"
              color="success"
            >
              <DoneIcon />
            </IconButton>
          ) : (
            <IconButton
              variant="outlined"
              className="align-cancelbutton"
              color="error"
            >
              <CloseIcon />
            </IconButton>
          )
        ) : row.attandence_status == 1 ? (
          "Full Day"
        ) : row.attandence_status == 2 ? (
          "Half Day"
        ) : (
          "Leave"
        ),
    },
  ]);

  // handle update success

  const handleUpdateSuccess = (updatedData) => {
    const updatedDay = moment(updatedData.date).date();
    const updatedDate = moment(updatedData.date).format("YYYY-MM-DD");
    const editedCellKey = `${updatedData.employeeId}-${updatedDate}`;

    setEditedCells((prev) => ({
      ...prev,
      [editedCellKey]: updatedData.reason,
    }));
    localStorage.setItem(
      editedAttendanceStorageKey,
      JSON.stringify({
        ...getStoredEditedCells(),
        [editedCellKey]: updatedData.reason,
      })
    );

    setMonthlyAttendanceReport((prev) =>
      prev.map((emp) => {
        if (String(emp.employee_id) === String(updatedData.employeeId)) {
          const updatedAttendance = {
            ...emp,
            [updatedDay]: Number(updatedData.status),
            [`reason_${updatedDay}`]: updatedData.reason,
            [`working_hours_${updatedDay}`]: updatedData.workingHours,
          };
          return updatedAttendance;
        }
        return emp;
      })
    );
  };

  // Dialog Box
  const AttendanceDetailDialog = ({
    open,
    onClose,
    employee,
    date,
    currentStatus,
    currentReason = "",
    onUpdateSuccess,
  }) => {
    const [status, setStatus] = useState(
      currentStatus ? currentStatus.toString() : "0"
    );
    const [reason, setReason] = useState(currentReason || "");

    const statusOptions = [
      {
        value: 0,
        label: "Not Applicable (NA)",
      },
      { value: 1, label: "Full Day (F)" },
      { value: 2, label: "Half Day (H)" },
      { value: 3, label: "Leave (L)" },
      { value: 4, label: "Casual Leave (CL)" },
      { value: 5, label: "Compensation Day (CO)" },
    ];

    const updateAttendanceAPI = async (attendanceData) => {
      const config = {
        method: "POST",
        url: employeeAttandenceAPI,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          intType: 17,
          employeeID: attendanceData.employeeId,
          date: moment(attendanceData.date).format("YYYY-MM-DD"),
          status: attendanceData.status,
          reason: attendanceData.reason,
        },
      };

      console.log("API Request:", config);

      try {
        const response = await axios(config);

        return response.data;
      } catch (error) {
        console.error("Error updating attendance:", error);
        throw error;
      }
    };

    const handleSubmit = async () => {
      if (!reason.trim()) {
        setError(true);
        return;
      }
      setError(false);
      try {
        setLoading(true);
        const updateData = {
          employeeId: employee.employee_id,
          date: moment(date).format("YYYY-MM-DD"),
          status: status,
          reason: reason,
        };

        const response = await updateAttendanceAPI(updateData);

        if (response?.success) {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: "Attendence Status Updated Successfully",
              messageType: "success",
            })
          );

          onUpdateSuccess({
            employeeId: employee.employee_id,
            date: moment(date).format("YYYY-MM-DD"),
            status,
            workingHours: response.workingHours,
            reason,
          });

          handleMonthlyAttendanceReport();
          onClose();
        } else {
          throw new Error(response?.message || "Update failed");
        }
      } catch (error) {
        console.error("Update Error:", {
          error: error.message,
        });
      } finally {
        setLoading(false);
      }
    };

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Attendance Details - {employee.employee_name}</DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle1" gutterBottom>
            Date: {moment(date).format("MMMM D, YYYY")}
          </Typography>

          <FormControl fullWidth margin="normal">
            <InputLabel>Attendance Status</InputLabel>
            <Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              label="Attendance Status"
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Reason for Change"
            multiline
            rows={4}
            fullWidth
            margin="normal"
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              if (e.target.value.trim()) setError(false);
            }}
            variant="outlined"
            placeholder="Enter the reason for attendance change"
            error={error}
            helperText={error ? "Reason is required." : ""}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const [currentDate, setCurrentDate] = React.useState(
    dayjs().format("YYYY-MM-DD")
  );

  return (
    <Layout>
      <AlertMessage ref={childRef} />
      <Grid className="employee-form bold-header">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Employee Attendance
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Employee</Typography>
              <Typography color="text.primary">Attendance</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid className="form_design">
          <Grid>
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    onChange={handleChange}
                    aria-label="attendance-report"
                  >
                    <Tab label="Daily Attendance Report" value="1" />
                    <Tab label="Monthly Attendance Report" value="2" />
                    {/* <Tab label="Yearly Attendance Report" value="3" />
                    <Tab label="Employee Project Report" value="4" /> */}
                  </TabList>
                </Box>
                <TabPanel value="1">
                  {/* <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Employee Name</StyledTableCell>
                        <StyledTableCell align="right">First In</StyledTableCell>
                        <StyledTableCell align="right">Last Out</StyledTableCell>
                        <StyledTableCell align="right">Total Hours</StyledTableCell>
                        <StyledTableCell align="right">Shift</StyledTableCell>
                        <StyledTableCell align="right">Attendance Status</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>

                      {attendanceReport.length > 0 ? attendanceReport.map((row) => (
                        <>
                          <StyledTableRow key={row.employee_name}>
                            <StyledTableCell component="th" scope="row">
                              {row.employee_name}
                            </StyledTableCell>
                            <StyledTableCell align="right">{row.start_time ? moment.utc(row.start_time).utcOffset("-02:30").format("MMM DD, YYYY, hh:mm A") : "-"}</StyledTableCell>
                            <StyledTableCell align="right">{row.end_time ? moment.utc(row.end_time).utcOffset("-02:30").format("MMM DD, YYYY, hh:mm A") : "-"}</StyledTableCell>
                            <StyledTableCell align="right">{row.working_hours ? row.working_hours : "-"}</StyledTableCell>
                            <StyledTableCell align="right">{(row.Shift) == 1 ? "Day Shift" : "Night Shift"}</StyledTableCell>
                            <StyledTableCell align="right">{(row.attandence_status) == 0 ? "leave" : (row.attandence_status) == 1 ? "Full Day" : "Half Day"}</StyledTableCell>
                          </StyledTableRow>
                        </>
                      )) :
                        <></>}
                    </TableBody>
                  </Table>
                </TableContainer> */}
                  <Grid className="excel_button" item xs={12} lg={12} md={12}>
                    <Button
                      className="btn-primary"
                      onClick={() => downloadDailyAttendanceExcel()}
                    >
                      Export to Excel
                    </Button>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    margin={`15px 0px`}
                    padding={`10px 15px 0px 0px`}
                  >
                    <Grid item xs={12} lg={3} md={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileDatePicker
                          label="From Date"
                          value={fromDate}
                          inputFormat="DD/MM/YYYY"
                          views={
                            value === "1"
                              ? ["year", "month", "day"]
                              : ["year", "month"]
                          }
                          onChange={(newValue) => {
                            setFromDate(newValue);
                          }}
                          maxDate={toDate} // Prevent selecting a fromDate after toDate
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} lg={3} md={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileDatePicker
                          label="To Date"
                          value={toDate}
                          inputFormat="DD/MM/YYYY"
                          views={
                            value === "1"
                              ? ["year", "month", "day"]
                              : ["year", "month"]
                          }
                          onChange={(newValue) => {
                            setToDate(newValue);
                          }}
                          minDate={fromDate} // Prevent selecting a toDate before fromDate
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>

                    {value == 1 && (
                      <Grid item xs={12} md={4} lg={3}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Employee List
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={employeeID}
                            inputFormat="DD/MM/YYYY"
                            label="Employee List"
                            onChange={(e) => {
                              setEmployeeID(e.target.value);
                            }}
                          >
                            {employeeList.map((row) => (
                              <MenuItem key={row.id} value={row.id}>
                                {row.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}
                    <Grid item xs={12} md={4} lg={3}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Company Name
                        </InputLabel>
                        <Select
                          labelId="Select Project"
                          id="demo-simple-select"
                          value={companyName}
                          label="Company name"
                          onChange={(e) => {
                            setCompanyName(e.target.value);
                          }}
                        >
                          {companyList.map((row, index) => (
                            <MenuItem value={row.id} key={index}>
                              {row.company_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={12} md={12} textAlign="right">
                      {/* <LoadingButton
                        size="large"
                        variant="contained"
                        className="button_yellow button_first"
                        onClick={() => {
                          setEmployeeID(0);
                          setCompanyName("");
                          // temprefs1.current = false;
                          // fetchAttendanceData(1);
                        }}
                      >
                        Clear
                      </LoadingButton> */}
                      <LoadingButton
                        size="large"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          temprefs1.current = false;
                          fetchAttendanceData(1);
                        }}
                      >
                        Submit
                      </LoadingButton>
                    </Grid>
                  </Grid>
                  <Grid>
                    <DataTable
                      pagination
                      paginationServer={!selectedStatusVal}
                      fixedHeader
                      fixedHeaderScrollHeight="550px"
                      columns={columns}
                      data={attendanceReport}
                      progressPending={loading}
                      paginationTotalRows={totalCount}
                      paginationDefaultPage={currentPage}
                      paginationRowsPerPageOptions={[1, 10, 25, 50, 100]}
                      paginationPerPage={rowsPerPage}
                      onChangePage={handlePageChange}
                      onSort={handleSort}
                      onChangeRowsPerPage={handleRowsPerPageChange}
                    />
                  </Grid>
                </TabPanel>
                <TabPanel value="2">
                  <Grid className="excel_button" item xs={12} lg={12} md={12}>
                    <Button
                      className="btn-primary"
                      onClick={() => downloadMonthlyAttendanceExcel()}
                    >
                      Export to Excel
                    </Button>
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    margin={`15px 0px`}
                    padding={`10px 15px 0px 0px`}
                  >
                    <Grid item xs={12} lg={2} md={2}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        format="DD-MM-YYYY"
                      >
                        <MobileDatePicker
                          label="Select Month & Year"
                          value={fromDate}
                          inputFormat="MM/YYYY"
                          fullWidth
                          views={
                            value == "1"
                              ? ["year", "month", "day"]
                              : ["year", "month"]
                          }
                          onChange={(e) => {
                            setFromDate(e);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label"></InputLabel>
                        {/* <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectedCompany}
                          label="Select Company"
                          // onChange={(e) => {
                          //   setCompanyName(e.target.value);
                          //   setValue("txtCompanyName", e.target.value);
                          // }}
                          onChange={handleCompanyChange}
                          renderValue={(selected) => (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {companyNames.find((item) => item.id === selected)
                                ?.company_name || "Select a company"}
                            </div>
                          )}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end" sx={{ mr: 2 }}>
                                <IconButton onClick={handleClear} edge="end">
                                  <ClearIcon sx={{ color: "#ff0a54" }} />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        >
                          {companyNames &&
                            companyNames.length > 0 &&
                            companyNames.map((row, index) => (
                              <MenuItem value={row.id} key={index}>
                                {row.company_name}
                              </MenuItem>
                            ))}
                        </Select> */}
                        <TextField
                          select
                          label="Company Name"
                          value={selectedCompany}
                          onChange={(e) => setSelectedCompany(e.target.value)}
                        >
                          {companyNames &&
                            companyNames.length > 0 &&
                            companyNames.map((row, index) => (
                              <MenuItem value={row.id} key={index}>
                                {row.company_name}
                              </MenuItem>
                            ))}
                        </TextField>
                        <Typography className="invalid-feedback">
                          {/* {errors.txtCompanyName?.message} */}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                      {/* <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Employee List
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={employeeID}
                          label="Employee List"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end" sx={{ mr: 2 }}>
                                <IconButton onClick={handleClear} edge="end">
                                  <ClearIcon sx={{ color: "#ff0a54" }} />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          onChange={(e) => {
                            setEmployeeID(e.target.value);
                          }}
                          renderValue={(selected) => (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {employeeList.find((item) => item.id === selected)
                                ?.name || "Select an employee"}
                            </div>
                          )}
                        >
                          {employeeList.map((row) => (
                            <MenuItem key={row.id} value={row.id}>
                              {row.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl> */}
                      <FormControl fullWidth>
                        <TextField
                          select
                          label="Employee list"
                          value={selectedEmployee}
                          onChange={(e) =>
                            setSelectedEmployeeList(e.target.value)
                          }
                        >
                          {/* <MenuItem key={""} value={0}>
                            All
                          </MenuItem> */}
                          {employeeList.map((row) => (
                            <MenuItem key={row.id} value={row.id}>
                              {row.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      lg={2}
                      md={2}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <LoadingButton
                        size="large"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          temprefs1.current = false;
                          handleMonthlyAttendanceReport();
                          setDaysinMonth(
                            new Date(fromDate).getFullYear(),
                            new Date(fromDate).getMonth()
                          );
                        }}
                      >
                        Submit
                      </LoadingButton>
                    </Grid>
                  </Grid>

                  <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2, mt: 3, flexWrap: "wrap", gap: 2 }}>
                    <Typography variant="h5" fontWeight="800" sx={{ color: "#0f172a" }}>
                      {new Date(fromDate).toLocaleString("default", { month: "long" })} Attendance List
                    </Typography>
                    <TextField
                      placeholder="Search by name"
                      variant="outlined"
                      size="small"
                      value={searchName}
                      onChange={(e) => setSearchName(e.target.value)}
                      sx={{ width: 250, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
                    />
                  </Box>
                  <Box sx={{ maxHeight: "650px", overflow: "auto", border: "1px solid #e2e8f0", borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.02)" }}>
                    <Table sx={{ minWidth: 700 }} stickyHeader aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell sx={{ position: "sticky", left: 0, zIndex: 3, background: "#0c54a0 !important" }}>
                            Employee Name / Date
                          </StyledTableCell>
                          <StyledTableCell>FULL DAY</StyledTableCell>
                          <StyledTableCell>HALF DAY</StyledTableCell>
                          <StyledTableCell>ABSENT</StyledTableCell>
                          <StyledTableCell>CASUAL LEAVE</StyledTableCell>
                          <StyledTableCell>COMPENSATORY DAYS</StyledTableCell>
                          <StyledTableCell>N/A</StyledTableCell>
                          <StyledTableCell>GRANTED WORKING DAYS</StyledTableCell>
                          {daysinMonth.map((date) => {
                            let newDate = "";
                            let display_date = "";
                            let month_name = "";
                            const currentDate = new Date(fromDate);

                            // Check if the date is less than or equal to 25, if so, it's in the current month
                            if (date <= 25) {
                              newDate = new Date(
                                currentDate.getFullYear(),
                                currentDate.getMonth(),
                                date
                              );
                              display_date = moment(newDate).format("ddd");
                              month_name = moment(newDate).format("MMM");
                            } else {
                              // Otherwise, it's in the previous month
                              newDate = new Date(
                                currentDate.getFullYear(),
                                currentDate.getMonth() - 1,
                                date
                              );
                              display_date = moment(newDate).format("ddd");
                              month_name = moment(newDate).format("MMM");
                            }
                            return (
                              <StyledTableCell>
                                <span>
                                  {date}
                                  &nbsp;
                                  {month_name}
                                  {"\n"}
                                  {display_date}
                                </span>
                              </StyledTableCell>
                            );
                          })}
                        </TableRow>
                      </TableHead>
                      {/* <TableBody>
                        {monthlyAttendanceReport.length > 0 ? (
                          monthlyAttendanceReport.map((employee) => {
                            let fullday = 0;
                            let halfday = 0;
                            let leave = 0;

                            for (let key in employee) {
                              if (employee[key] === 1) {
                                fullday++;
                              } else if (employee[key] === 2) {
                                halfday++;
                              } else if (employee[key] === 3) {
                                leave++;
                              }
                            }

                            return (
                              <StyledTableRow key={employee.employee_id}>
                                <StyledTableCell align='right'>
                                  <Link
                                    href={`/employee-attendance-report/${employee.employee_id}`}
                                  >
                                    {employee.employee_name}
                                  </Link>
                                </StyledTableCell>
                                <StyledTableCell align='right'>
                                  {fullday}
                                </StyledTableCell>
                                <StyledTableCell align='right'>
                                  {halfday}
                                </StyledTableCell>
                                <StyledTableCell align='right'>
                                  {leave}
                                </StyledTableCell>
                                {daysinMonth.map((day) => {
                                  var d = new Date();
                                  var newDate = new Date(
                                    d.getFullYear(),
                                    d.getMonth(),
                                    day
                                  );

                                  return Object.keys(employee).map(
                                    (attendance_date) => {
                                      return day == attendance_date ? (
                                        <StyledTableCell
                                          align='right'
                                          key={day}
                                        >
                                          {employee[day] === 0 ? (
                                            'NA'
                                          ) : employee[day] === 1 ? (
                                            <a
                                              className='full-day-attendance'
                                              onClick={() => {
                                                navigate(
                                                  `/employee-attendance-report/${
                                                    employee.employee_id
                                                  }-${moment(newDate).format(
                                                    'YYYY.MM.DD'
                                                  )}`
                                                );
                                              }}
                                            >
                                              F
                                            </a>
                                          ) : employee[day] === 2 ? (
                                            <a
                                              className='half-day-attendance'
                                              onClick={() => {
                                                navigate(
                                                  `/employee-attendance-report/${
                                                    employee.employee_id
                                                  }-${moment(newDate).format(
                                                    'YYYY.MM.DD'
                                                  )}`
                                                );
                                              }}
                                            >
                                              H
                                            </a>
                                          ) : employee[day] === 3 ? (
                                            <span className='leave-attendance'>
                                              L
                                            </span>
                                          ) : moment(new Date()).format('DD') <
                                            day ? (
                                            '-'
                                          ) : newDate.getDay() === 0 ? (
                                            <span className='sunday-attendance'>
                                              S
                                            </span>
                                          ) : (
                                            <span className='nodata-attendance'>
                                              NA
                                            </span>
                                          )}
                                        </StyledTableCell>
                                      ) : null;
                                    }
                                  );
                                })}
                              </StyledTableRow>
                            );
                          })
                        ) : (ß
                          <StyledTableRow>
                            <StyledTableCell
                              colSpan={daysinMonth.length + 5}
                              align='center'
                            >
                              No data available
                            </StyledTableCell>
                          </StyledTableRow>
                        )}
                      </TableBody> */}

                      <TableBody>
                        {monthlyAttendanceReport.length > 0 ?
                          monthlyAttendanceReport
                            .filter(emp => !searchName || (emp.employee_name && emp.employee_name.toLowerCase().includes(searchName.toLowerCase())))
                            .slice(monthlyPage * monthlyRowsPerPage, monthlyPage * monthlyRowsPerPage + monthlyRowsPerPage)
                            .map((employee) => {
                              let fullday = 0;
                              let halfday = 0;
                              let leave = 0;
                              let casualLeave = 0;
                              let compensation = 0;
                              let naDays = 0;

                              for (let key in employee) {
                                if (!isNaN(key)) {
                                  if (employee[key] === 1) {
                                    fullday++;
                                  } else if (employee[key] === 2) {
                                    halfday++;
                                  } else if (employee[key] === 3) {
                                    leave++;
                                  } else if (employee[key] === 4) {
                                    casualLeave++;
                                  } else if (employee[key] === 5) {
                                    compensation++;
                                  } else if (employee[key] === 0) {
                                    naDays++;
                                  }
                                }
                              }
                              let paidSundays = 0;
                              const currentDate = new Date(fromDate);
                              daysinMonth.forEach((day) => {
                                const dayInt = parseInt(day);
                                let newDate;
                                if (dayInt <= 25) {
                                  newDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), dayInt);
                                } else {
                                  newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, dayInt);
                                }
                                if (newDate.getDay() === 0) { // Sunday
                                  const status = employee[dayInt];
                                  if (status !== 0) { // Not N/A
                                    const isUnpaid = (date) => {
                                      if (date.getDay() === 0) return false;
                                      const s = employee[date.getDate()];
                                      return s === 3 || s === 0 || s === undefined || s === null;
                                    };
                                    const satDate = new Date(newDate);
                                    satDate.setDate(newDate.getDate() - 1);
                                    const monDate = new Date(newDate);
                                    monDate.setDate(newDate.getDate() + 1);
                                    if (!(isUnpaid(satDate) && isUnpaid(monDate))) {
                                      paidSundays++;
                                    }
                                  }
                                }
                              });

                              const finalLeave = Math.max(0, leave - paidSundays);
                              const totalWorkingDays = fullday + (halfday * 0.5) + casualLeave + compensation + paidSundays;

                              return (
                                <StyledTableRow key={employee.employee_name}>
                                  <StyledTableCell align="left" sx={{ position: "sticky", left: 0, zIndex: 1, background: "#fff !important" }}>
                                    <Link
                                      href={`/employee-attendance-report/${employee.employee_id}`}
                                    >
                                      {employee.employee_name}
                                    </Link>
                                  </StyledTableCell>
                                <StyledTableCell align="center">
                                  {fullday}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {halfday}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {finalLeave}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {casualLeave}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {compensation}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {naDays}
                                </StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }}>
                                  {totalWorkingDays}
                                </StyledTableCell>
                                {daysinMonth.map((day) => {
                                  return Object.keys(employee).map(
                                    (attandence_date) => {
                                      // var d = new Date();
                                      // var newDate = new Date(
                                      //   d.getFullYear(),
                                      //   d.getMonth(),
                                      //   day
                                      // );
                                      const currentDate = new Date(fromDate);
                                      let newDate;

                                      // Match the exact same date logic as in the header
                                      if (day <= 25) {
                                        newDate = new Date(
                                          currentDate.getFullYear(),
                                          currentDate.getMonth(),
                                          day
                                        );
                                      } else {
                                        newDate = new Date(
                                          currentDate.getFullYear(),
                                          currentDate.getMonth() - 1,
                                          day
                                        );
                                      }
                                      const reasonVal = employee[`reason_${day}`];
                                      const cellDate = moment(newDate).format("YYYY-MM-DD");
                                      const editedCellReason = editedCells[
                                        `${employee.employee_id}-${cellDate}`
                                      ];
                                      const displayedReason = reasonVal || editedCellReason;
                                      const isEditedAttendanceCell = Boolean(displayedReason);

                                      return (
                                        day == attandence_date && (
                                          <StyledTableCell
                                            align="center"
                                            key={day}
                                            className={isEditedAttendanceCell ? "changed-attendance-cell" : ""}
                                          >
                                            {(() => {
                                              const cellContent = employee[day] == 0 ? (
                                                <a
                                                  onClick={(e) => {
                                                    setSelectedEmployees(employee);
                                                    setSelectedDate(newDate);
                                                    setSelectedStatus(0);
                                                    setSelectedReason(employee[`reason_${day}`] || "");
                                                    setDialogOpen(true);
                                                  }}
                                                >
                                                  NA
                                                </a>
                                              ) : employee[day] == 1 ? (
                                                <a
                                                  className="full-day-attendance"
                                                  onClick={(e) => {
                                                    setSelectedEmployees(employee);
                                                    setSelectedDate(newDate);
                                                    setSelectedStatus(1);
                                                    setSelectedReason(employee[`reason_${day}`] || "");
                                                    setDialogOpen(true);
                                                  }}
                                                >
                                                  F
                                                </a>
                                              ) : employee[day] == 2 ? (
                                                <a
                                                  className="full-day-attendance"
                                                  onClick={(e) => {
                                                    setSelectedEmployees(employee);
                                                    setSelectedDate(newDate);
                                                    setSelectedStatus(2);
                                                    setSelectedReason(employee[`reason_${day}`] || "");
                                                    setDialogOpen(true);
                                                  }}
                                                >
                                                  H
                                                </a>
                                              ) : employee[day] == 3 ? (
                                                <span className="leave-attendance">
                                                  <a
                                                    className="full-day-attendance"
                                                    onClick={(e) => {
                                                      setSelectedEmployees(employee);
                                                      setSelectedDate(newDate);
                                                      setSelectedStatus(3);
                                                      setSelectedReason(employee[`reason_${day}`] || "");
                                                      setDialogOpen(true);
                                                    }}
                                                  >
                                                    L
                                                  </a>
                                                </span>
                                              ) : employee[day] == 4 ? (
                                                <span className="casual-leave-attendance">
                                                  <a
                                                    className="full-day-attendance casual-leave-attendance"
                                                    onClick={(e) => {
                                                      setSelectedEmployees(employee);
                                                      setSelectedDate(newDate);
                                                      setSelectedStatus(4);
                                                      setSelectedReason(employee[`reason_${day}`] || "");
                                                      setDialogOpen(true);
                                                    }}
                                                  >
                                                    CL
                                                  </a>
                                                </span>
                                              ) : employee[day] == 5 ? (
                                                <span className="compensation-attendance">
                                                  <a
                                                    className="full-day-attendance compensation-attendance"
                                                    onClick={(e) => {
                                                      setSelectedEmployees(employee);
                                                      setSelectedDate(newDate);
                                                      setSelectedStatus(5);
                                                      setSelectedReason(employee[`reason_${day}`] || "");
                                                      setDialogOpen(true);
                                                    }}
                                                  >
                                                    CO
                                                  </a>
                                                </span>
                                              ) : moment(new Date()).format(
                                                  "DD"
                                                ) < day ? (
                                                "-"
                                              ) : newDate.getDay() == 0 ? (
                                                <span>
                                                  <a
                                                    className="sunday-attendance"
                                                    onClick={(e) => {
                                                      setSelectedEmployees(employee);
                                                      setSelectedDate(newDate);
                                                      setSelectedStatus(0);
                                                      setSelectedReason(employee[`reason_${day}`] || "");
                                                      setDialogOpen(true);
                                                    }}
                                                  >
                                                    S
                                                  </a>
                                                </span>
                                              ) : (
                                                <span>
                                                  <a
                                                    className="nodata-attendance"
                                                    onClick={(e) => {
                                                      setSelectedEmployees(employee);
                                                      setSelectedDate(newDate);
                                                      setSelectedStatus(0);
                                                      setSelectedReason(employee[`reason_${day}`] || "");
                                                      setDialogOpen(true);
                                                    }}
                                                  >
                                                    NA
                                                  </a>
                                                </span>
                                              );

                                              return isEditedAttendanceCell ? (
                                                <Tooltip title={displayedReason} arrow placement="top">
                                                  <span>{cellContent}</span>
                                                </Tooltip>
                                              ) : (
                                                cellContent
                                              );
                                            })()}
                                          </StyledTableCell>
                                        )
                                      );
                                    }
                                  )
                                })}
                              </StyledTableRow>
                            );
                          })
                        :
                          <></>
                        }
                        {dialogOpen && selectedEmployees && (
                          <AttendanceDetailDialog
                            open={dialogOpen}
                            onClose={() => setDialogOpen(false)}
                            employee={selectedEmployees}
                            date={selectedDate}
                            currentStatus={selectedStatus}
                            currentReason={selectedReason}
                            onUpdateSuccess={handleUpdateSuccess}
                          />
                        )}
                      </TableBody>
                    </Table>
                  </Box>
                  <Box sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: "1px solid #e2e8f0", background: "#f8fafc", borderBottomLeftRadius: "12px", borderBottomRightRadius: "12px" }}>
                    <Typography variant="body2" color="textSecondary" fontWeight="600">
                      Showing {monthlyPage * monthlyRowsPerPage + 1} - {Math.min((monthlyPage + 1) * monthlyRowsPerPage, monthlyAttendanceReport.filter(emp => !searchName || (emp.employee_name && emp.employee_name.toLowerCase().includes(searchName.toLowerCase()))).length)} of {monthlyAttendanceReport.filter(emp => !searchName || (emp.employee_name && emp.employee_name.toLowerCase().includes(searchName.toLowerCase()))).length} Employee(s)
                    </Typography>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      component="div"
                      count={monthlyAttendanceReport.filter(emp => !searchName || (emp.employee_name && emp.employee_name.toLowerCase().includes(searchName.toLowerCase()))).length}
                      rowsPerPage={monthlyRowsPerPage}
                      page={monthlyPage}
                      onPageChange={(e, newPage) => setMonthlyPage(newPage)}
                      onRowsPerPageChange={(e) => {
                        setMonthlyRowsPerPage(parseInt(e.target.value, 10));
                        setMonthlyPage(0);
                      }}
                    />
                  </Box>
                </TabPanel>
                <TabPanel value="3">
                  <Grid
                    container
                    spacing={2}
                    margin={`15px 0px`}
                    padding={`10px 15px 0px 0px`}
                  >
                    <Grid item xs={12} lg={4} md={4}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        format="DD-MM-YYYY"
                      >
                        <MobileDatePicker
                          label="From Date"
                          value={fromDate}
                          inputFormat="DD/MM/YYYY"
                          fullWidth
                          views={["year", "month"]}
                          onChange={(e) => {
                            setFromDate(e);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} lg={4} md={4}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        format="YYYY-MM-DD"
                      >
                        <MobileDatePicker
                          label="To Date"
                          value={toDate}
                          inputFormat="DD/MM/YYYY"
                          fullWidth
                          views={["year", "month"]}
                          onChange={(e) => {
                            setToDate(e);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} lg={12} md={12} textAlign="right">
                      <LoadingButton
                        size="large"
                        variant="contained"
                        className="button_yellow button_first"
                        onClick={() => {
                          temprefs1.current = false;
                          fetchAttendanceData(1, 10, 8);
                        }}
                      >
                        Clear
                      </LoadingButton>
                      <LoadingButton
                        size="large"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          temprefs1.current = false;
                          fetchAttendanceData(1, 10, 10);
                        }}
                      >
                        Submit
                      </LoadingButton>
                    </Grid>
                  </Grid>
                  <Grid>
                    <Typography></Typography>
                  </Grid>
                </TabPanel>
                <TabPanel value="4">
                  <Grid
                    container
                    spacing={2}
                    margin={`15px 0px`}
                    padding={`10px 15px 0px 0px`}
                  >
                    <Grid item xs={12} md={4} lg={4}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Employee List
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={employeeID}
                          label="Employee List"
                          onChange={(e) => {
                            setEmployeeID(e.target.value);
                          }}
                        >
                          {employeeList.map((row) => (
                            <MenuItem key={row.id} value={row.id}>
                              {row.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        format="DD-MM-YYYY"
                      >
                        <MobileDatePicker
                          label="Date of Birth"
                          value={currentDate}
                          inputFormat="DD/MM/YYYY"
                          fullWidth
                          // minDate={new Date("02-01-2020")}
                          // maxDate={new Date("02-29-2020")}
                          onChange={(newValue) => {
                            setCurrentDate(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              // helperText={errors.txtDob?.message}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                      <LoadingButton
                        size="large"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          temprefs1.current = false;
                          fetchAttendanceData(1);
                        }}
                      >
                        Submit
                      </LoadingButton>
                    </Grid>
                  </Grid>
                </TabPanel>
              </TabContext>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      {/* <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Update Attendance</DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="normal">
            <InputLabel>Attendance Type</InputLabel>
            <Select
              value={attendanceType}
              onChange={(e) => setAttendanceType(e.target.value)}
              label="Attendance Type"
            >
              <MenuItem value="Leave">Leave</MenuItem>
              <MenuItem value="Full Day">Full Day</MenuItem>
              <MenuItem value="Half Day">Half Day</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Reason"
            fullWidth
            margin="normal"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            Submit
          </Button>
        </DialogActions>
      </Dialog> */}
    </Layout>
  );
}

export default EmployeeAttendance;
